import View from "./general-info.view";
import Presenter from "./general-info.presenter";
import { ConnectComponent } from "util";

export default ConnectComponent(View, Presenter);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/general-info/index.js